import React from 'react'
import CountUp from 'react-countup'
import { graphql, useStaticQuery } from 'gatsby'

import {
  Section,
  Container,
  ChoreCountContainer,
  Header,
  Text,
  ImageContainer,
  Count,
  CalendarSyncsContainer,
  SubTitle,
  IconsContainer,
  Card,
  IconText,
  Icon,
} from './styles'

const TOTAL_CHORES_COMPLETED = 275302324
const COUNT_UP_TICKS = 60000

const smoothEasing = (t, b, c, d) => (c * t) / d + b
const Counter = () => {
  const { google, outlook, apple, cozi, yahoo, checkmark } = useStaticQuery(graphql`
    query CounterQuery {
      google: file(relativePath: { eq: "calendar/syncs/google.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      outlook: file(relativePath: { eq: "calendar/syncs/outlook.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      apple: file(relativePath: { eq: "calendar/syncs/apple.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      cozi: file(relativePath: { eq: "calendar/syncs/cozi.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      yahoo: file(relativePath: { eq: "calendar/syncs/yahoo.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      checkmark: file(relativePath: { eq: "calendar/checkbox-round.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 40, layout: FIXED, placeholder: NONE)
        }
      }
    }
  `)
  const CALENDAR_SYNCS_CONSTANTS = [
    {
      image: google,
      alt: 'Google Calendar Logo',
      text: `Google`,
    },
    {
      image: outlook,
      alt: 'Outlook Calendar Logo',
      text: 'Outlook',
    },
    {
      image: apple,
      alt: 'Apple Calendar Logo',
      text: 'Apple',
    },
    {
      image: cozi,
      alt: 'Cozi Calendar Logo',
      text: 'Cozi',
    },
    {
      image: yahoo,
      alt: 'Yahoo Calendar Logo',
      text: 'Yahoo',
    },
  ]
  return (
    <Section>
      <CalendarSyncsContainer>
        <SubTitle>Seamlessly auto-syncs with:</SubTitle>
        <IconsContainer>
          {CALENDAR_SYNCS_CONSTANTS.map((calendar, index) => (
            <Card key={index}>
              <Icon image={calendar.image.childImageSharp.gatsbyImageData} alt={calendar.alt} />
              <IconText>{calendar.text}</IconText>
            </Card>
          ))}
        </IconsContainer>
      </CalendarSyncsContainer>
      <Container>
        <Header>Bringing families together, one chore at a time.</Header>
        <ChoreCountContainer>
          <ImageContainer>
            <Icon image={checkmark.childImageSharp.gatsbyImageData} alt="checkmark" />
          </ImageContainer>
          <CountUp
            delay={0}
            start={TOTAL_CHORES_COMPLETED - COUNT_UP_TICKS}
            end={TOTAL_CHORES_COMPLETED}
            duration={7}
            separator=","
            decimals={0}
            useEasing
            easingFn={smoothEasing}
            useGrouping
            decimal=","
            preserveValue
          >
            {({ countUpRef }) => <Count ref={countUpRef} />}
          </CountUp>
        </ChoreCountContainer>
        <Text>Chores Completed</Text>
      </Container>
    </Section>
  )
}

export default Counter
